module.exports = __webpack_public_path__ + "media/app/assets/imgs/landing_2025/icon-facebook-450e03e2317131ee9f715bd7186960df.png";